import axios from 'axios';

const url = process.env.REACT_APP_SERVER_URL || 'api.palladiumwallet.st';
const api = axios.create({
  baseURL: `https://${url}/api`, 
  withCredentials: false, 
  headers: {
    'Accept': 'application/json' 
  }
});

// Добавляем интерцептор для автоматического добавления Bearer token
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
